// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2RJdxuh0s1lsJQ {\n  align-items: center;\n  margin: unset;\n  margin-left: auto;\n  height: auto;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customizeViewButton": "_2RJdxuh0s1lsJQ"
};
export default ___CSS_LOADER_EXPORT___;
